import * as style from "./services.module.scss";
import {Link} from "gatsby";
import * as React from "react";

const Services = () => {
    return (
        <div className={style.topGradient}>
            <div className="container">
                <div className="row">
                    <div className="col-md-6 bg-primary">
                        <div className="text-white p-4 my-5"
                             data-sal="slide-down" data-sal-delay="300" data-sal-easing="ease-in-sine" data-sal-duration="400">
                            <h2 className="text-center fw-bold">Podologia</h2>
                            <div className="container-fluid fs-5">
                                <p>
                                    <i className="bi-arrow-right-square-fill pe-2"></i>
                                    Diagnostyka dolegliwości kończyn dolnych
                                </p>
                                <p>
                                    <i className="bi-arrow-right-square-fill pe-2"></i>
                                    Specjalistyczne metody leczenia stóp i paznokci
                                </p>

                                <p>
                                    <i className="bi-arrow-right-square-fill pe-2"></i>
                                    Skuteczność w rozwiązywaniu problemów
                                </p>
                                <p>
                                    <i className="bi-arrow-right-square-fill pe-2"></i>
                                    Połączenie wiedzy i praktycznych umiejętności
                                </p>
                            </div>
                            <div className="text-center">
                                <Link className="btn btn-secondary btn-lg me-2 mt-2" to="/podologia" role="button">
                                    <i className="bi-chevron-double-right pe-2"></i> Zapoznaj się z możliwościami podologa
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 bg-monochromatic">
                        <div className="text-white p-4 my-5" data-sal="slide-down" data-sal-delay="400" data-sal-duration="400">
                            <h2 className="fw-bold text-center">Refleksologia</h2>
                            <div className="container-fluid fs-5">
                                <p>
                                    <i className="bi-arrow-right-square-fill pe-2"></i>
                                    Pobudzenie układu nerwowego oraz układu krążenia
                                </p>
                                <p>
                                    <i className="bi-arrow-right-square-fill pe-2"></i>
                                    Regulacja pracy narządów wewnętrznych
                                </p>
                                <p>
                                    <i className="bi-arrow-right-square-fill pe-2"></i>
                                    Wspomaganie kontroli napięcia mięśniowego
                                </p>
                                <p>
                                    <i className="bi-arrow-right-square-fill pe-2"></i>
                                    Terapia stresu i odprężenie dla całego ciała
                                </p>
                            </div>
                            <div className="text-center">
                                <Link className="btn btn-secondary btn-lg me-2 mt-2" to="/refleksologia" role="button">
                                    <i className="bi-chevron-double-right pe-2"></i> Dowiedz się więcej o refleksologii
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Services